export enum FaceToFaceInitialStatusEnum {
  DoesNotExist = 1,
  ScheduledForFuture = 2,
  AlreadyConducted = 3
}

export const FaceToFaceInitialStatusOptions = [
{ id: 1, label: 'Does Not Exist' },
{ id: 2, label: 'Scheduled For Future' },
{ id: 3, label: 'Already Conducted' }
];
